export default  {
    PERMIT_ALL: "PERMIT_ALL",
    PERMIT_GRADE: "PERMIT_GRADE",
    PERMIT_PARTIAL: "PERMIT_PARTIAL",
}